'use strict';

module.exports = Object.freeze({
	zh_TW: '繁體中文',
	en_US: 'English',
	zh_CN: '简体中文',
	// ru_RU: 'Руская',
	// ko_KR: '한국어',
	// th_TH: 'ไทย',
});
